import { render, staticRenderFns } from "./baseStaffRecordDetailPrint.vue?vue&type=template&id=627fb5e1"
import script from "./baseStaffRecordDetailPrint.vue?vue&type=script&lang=js"
export * from "./baseStaffRecordDetailPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627fb5e1')) {
      api.createRecord('627fb5e1', component.options)
    } else {
      api.reload('627fb5e1', component.options)
    }
    module.hot.accept("./baseStaffRecordDetailPrint.vue?vue&type=template&id=627fb5e1", function () {
      api.rerender('627fb5e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hireManagement/components/baseStaffRecordDetailPrint.vue"
export default component.exports